import { render, staticRenderFns } from "./r-ad-unit-dialog.vue?vue&type=template&id=25db9f60&scoped=true"
import script from "./r-ad-unit-dialog.vue?vue&type=script&lang=js"
export * from "./r-ad-unit-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-ad-unit-dialog.vue?vue&type=style&index=0&id=25db9f60&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25db9f60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25db9f60')) {
      api.createRecord('25db9f60', component.options)
    } else {
      api.reload('25db9f60', component.options)
    }
    module.hot.accept("./r-ad-unit-dialog.vue?vue&type=template&id=25db9f60&scoped=true", function () {
      api.rerender('25db9f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/ad-settings/unit/r-ad-unit-dialog.vue"
export default component.exports